__turbopack_context__.v({
  "checkMark": "CnOComparison-module__KvyP3W__checkMark",
  "checkmark": "CnOComparison-module__KvyP3W__checkmark",
  "chevronButton": "CnOComparison-module__KvyP3W__chevronButton",
  "cnoComparison": "CnOComparison-module__KvyP3W__cnoComparison",
  "cross": "CnOComparison-module__KvyP3W__cross",
  "dropdownArrow": "CnOComparison-module__KvyP3W__dropdownArrow",
  "dropdownHeader": "CnOComparison-module__KvyP3W__dropdownHeader",
  "dropdownText": "CnOComparison-module__KvyP3W__dropdownText",
  "featureCol": "CnOComparison-module__KvyP3W__featureCol",
  "featureHeader": "CnOComparison-module__KvyP3W__featureHeader",
  "featureRow": "CnOComparison-module__KvyP3W__featureRow",
  "featureValue": "CnOComparison-module__KvyP3W__featureValue",
  "headSection": "CnOComparison-module__KvyP3W__headSection",
  "headerCell": "CnOComparison-module__KvyP3W__headerCell",
  "mobileContainer": "CnOComparison-module__KvyP3W__mobileContainer",
  "mobileStickyHeader": "CnOComparison-module__KvyP3W__mobileStickyHeader",
  "mobileTable": "CnOComparison-module__KvyP3W__mobileTable",
  "pro": "CnOComparison-module__KvyP3W__pro",
  "stickyTableHeader": "CnOComparison-module__KvyP3W__stickyTableHeader",
  "table": "CnOComparison-module__KvyP3W__table",
  "tableContainer": "CnOComparison-module__KvyP3W__tableContainer",
  "ultrahumanCol": "CnOComparison-module__KvyP3W__ultrahumanCol",
  "ultrahumanHeader": "CnOComparison-module__KvyP3W__ultrahumanHeader",
});
